import React from "react";

const Icon = ({ name }) => {
  if (name === "save") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 5h14v16H5V5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M8 5v6h8V5M8 18h8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "refresh") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M20 12a8 8 0 1 1-2.34-5.66"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M20 4v6h-6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return null;
};
/**
 * ボタンコンポーネント
 * @param {string} title ボタンタイトル
 * @param {string} icon アイコン名
 * @param {Function} onClick ボタン押下時の処理
 * @param {ref} buttonRef ボタン Ref
 * @param {string} className クラス名
 * @class Button
 */
export default function OutlineButton({
  title,
  icon,
  onClick,
  buttonRef,
  className = "",
}) {
  return (
    <button
      className={`btn btn-outline ${className}`}
      onClick={onClick}
      ref={buttonRef}
    >
      <Icon name={icon} />
      {title}
    </button>
  );
}
